(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('parameterization-docs', {
            parent: 'admin',
            url: '/parameterization-docs',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_PARTNER', 'ROLE_SUPERADMIN'],
                pageTitle: 'parameterizationDocs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/parameterization-docs/parameterization-docs.html',
                    controller: 'ParameterizationDocsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('parameterizationDocs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
